import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGavel } from '@fortawesome/free-solid-svg-icons'

import './styles.css';

export default function Publity({ handleAnchor }) {

    return (
        <div className="content-publity content">
            <div className="publity-img">
                <img src="https://connectadv.com.br/wp-content/uploads/2019/11/plataforma-de-solucoes-juridicas-para-empresas.jpg" />
            </div>

            <div className="content-right">
                <FontAwesomeIcon icon={faGavel} size="4x" color="#eee" style={{color:'#bf9f62', marginBottom:20}} />
                <h2 style={{textAlign:'center'}}>Compartilhando soluções inteligentes</h2>
                <ul style={{ listStyleType: 'none', textAlign: 'center' }}>
                    <li>Nossa missão é a defesa dos interesses de nossos clientes, priorizando um atendimento personalizado e com a máxima confiabilidade.</li>
                </ul>

                <p>Gostei quero falar com um advogado:</p>
                <div className="publity-buttons">
                    <button onClick={handleAnchor}>QUERO FALAR COM ADVOCACIA</button>
                </div>
            </div>
        </div>
    )
}